import { FPS } from "../tokens";

// Converts a frame index into a match-clock string like "62:14".
// Assumes frame 0 = kickoff of the loaded clip (not necessarily 0:00 of
// the real match — there's no half/added-time metadata in tracking.csv
// yet, so this is "elapsed time in the loaded clip", not the true match minute).
export function frameToClock(frameIdx) {
  const totalSeconds = Math.floor(frameIdx / FPS);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
}
